import { v4 as uuid } from 'uuid';

import { SECTION_TYPES, CARD_TYPES, SECTION_STATUS } from '@/modules/UserEventLanding/constants';

const sectionStatusText = (main) => `Раздел появится, когда ${main}`;

export const SECTIONS_DATA = {
  [SECTION_TYPES.GENERIC]: () => ({
    title: '',
    enabled: true,
    status: null,
    attrs: {
      class: 'redesignPrimaryLighten',
      isMock: true,
    },
    addons: {},
    preventEditable: true,
    component: {
      type: SECTION_TYPES.GENERIC,
      cardType: null,
      preventStyles: true,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionCustom.vue'),
      attrs: {
        id: 'emptyCustomSection',
      },
      listeners: {},
    },
    editor: {
      replacement: false,
      addition: false,
      deletable: false,
      activate: false,
    },
  }),
  [SECTION_TYPES.UNITS]: () => ({
    title: 'Программа',
    icon: '$ui-list',
    enabled: false,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('будет добавлен хотя бы 1 этап'),
    },
    attrs: {
      softDisabled: true,
      class: 'redesignBackground',
    },
    addons: {},
    component: {
      type: SECTION_TYPES.UNITS,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionProgram.vue'),
      attrs: {
        id: 'program',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.MAIN]: () => ({
    title: '',
    enabled: true,
    preventEditable: true,
    status: null,
    attrs: {
      class: 'redesignBackground',
    },
    addons: {},
    component: {
      type: SECTION_TYPES.MAIN,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionMain.vue'),
      preventStyles: true,
      attrs: {
        id: 'main',
      },
      listeners: {},
    },
    editor: {
      replacement: false,
      addition: false,
      deletable: false,
      activate: false,
    },
  }),
  [SECTION_TYPES.ABOUT]: () => ({
    title: 'О мероприятии',
    icon: '$ui-information-circle',
    enabled: true,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('будут заполнены основные поля'),
    },
    attrs: {
      softDisabled: true,
      class: 'redesignControlsBackground',
    },
    addons: {},
    component: {
      type: SECTION_TYPES.ABOUT,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionAbout.vue'),
      attrs: {
        id: 'about',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.NEWS]: () => ({
    title: 'Новости',
    icon: '$ui-news',
    enabled: false,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('будет опубликована хотя бы 1 новость'),
      title: 'Добавьте новость',
    },
    attrs: {
      class: 'redesignControlsBackground',
    },
    addons: {},
    component: {
      type: SECTION_TYPES.NEWS,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionNews.vue'),
      attrs: {
        id: 'news',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.EXPERTS]: () => ({
    title: 'Эксперты, жюри',
    icon: '$ui-star',
    enabled: false,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('будет добавлен хотя бы 1 эксперт'),
      title: 'Добавьте эксперта',
    },
    attrs: {
      class: 'redesignBackground',
    },
    addons: {},
    component: {
      type: SECTION_TYPES.EXPERTS,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionExperts.vue'),
      attrs: {
        id: 'experts',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.RESULTS]: () => ({
    title: 'Результаты',
    icon: '$ui-checklist',
    enabled: false,
    status: {
      always: SECTION_STATUS.ACTIVE,
      state: SECTION_STATUS.ACTIVE,
      text: sectionStatusText('в мероприятии будет хотя бы 1 участник'),
    },
    addons: {
      confettiBackground: true,
    },
    attrs: {
      class: 'redesignControlsBackground',
    },
    component: {
      type: SECTION_TYPES.RESULTS,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionResults.vue'),
      attrs: {
        id: 'results',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.GALLERY]: () => ({
    title: 'Галерея',
    icon: '$ui-photo',
    enabled: false,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('появится хотя бы 1 фото'),
      title: 'Добавьте медиафайлы',
    },
    addons: {},
    attrs: {
      class: 'redesignBackground',
    },
    component: {
      type: SECTION_TYPES.GALLERY,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionGallery.vue'),
      attrs: {
        id: 'gallery',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.PARTNERS]: () => ({
    title: 'Партнёры',
    icon: '$ui-case',
    enabled: false,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('будет добавлен хотя бы 1 партнёр'),
      title: 'Добавьте партнёра',
    },
    addons: {},
    attrs: {
      class: 'redesignBackground',
    },
    component: {
      type: SECTION_TYPES.PARTNERS,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionPartners.vue'),
      attrs: {
        id: 'partners',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.MEMBERS_INFO]: () => ({
    title: 'Участникам',
    icon: '$ui-user-group',
    enabled: true,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('будут заполнены правила участия, цели и задачи или документы'),
      title: 'Добавьте информацию',
    },
    addons: {},
    attrs: {
      class: 'redesignControlsBackground',
    },
    component: {
      type: SECTION_TYPES.MEMBERS_INFO,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionInfo.vue'),
      attrs: {
        id: 'info',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.AWARDS]: () => ({
    title: 'Награды',
    icon: '$ui-trophy',
    enabled: false,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('будет добавлена хотя бы 1 награда'),
      title: 'Добавьте награды',
    },
    addons: {},
    attrs: {
      class: 'redesignBackground',
    },
    component: {
      type: SECTION_TYPES.AWARDS,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionAwards.vue'),
      attrs: {
        id: 'awards',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.VIDEO_PRESENTATION]: () => ({
    title: 'Видеопрезентация',
    icon: '$ui-video-camera',
    enabled: false,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('будет добавлена ссылка на видеоролик'),
      title: 'Добавьте видео',
    },
    addons: {},
    attrs: {
      class: 'redesignBackground',
    },
    component: {
      type: SECTION_TYPES.VIDEO_PRESENTATION,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionVideoPresentation.vue'),
      attrs: {
        id: 'video_presentation',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.VOTE]: () => ({
    title: 'Голосование',
    icon: '$ui-document-check',
    enabled: false,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('появится хотя бы 1 голосование'),
      title: 'Добавьте голосование',
    },
    addons: {},
    attrs: {
      class: 'redesignBackground',
    },
    component: {
      type: SECTION_TYPES.VOTE,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionVote.vue'),
      attrs: {
        id: 'vote',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.EXHIBITION]: () => ({
    title: 'Выставки',
    icon: '$ui-cards',
    enabled: false,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('появится хотя бы 1 выставка'),
      title: 'Добавьте выставку',
    },
    addons: {},
    attrs: {
      class: 'redesignBackground',
    },
    component: {
      type: SECTION_TYPES.EXHIBITION,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionExhibitions.vue'),
      attrs: {
        id: 'exhibition',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
  [SECTION_TYPES.ASSOCIATIONS]: () => ({
    title: 'Проводится под эгидой',
    icon: '$ui-tag',
    enabled: false,
    status: {
      state: SECTION_STATUS.DRAFT,
      text: sectionStatusText('появится хотя бы 1 ассоциация'),
      title: 'Станьте членом ассоциации',
    },
    addons: {},
    attrs: {
      class: 'redesignBackground',
    },
    component: {
      type: SECTION_TYPES.ASSOCIATIONS,
      is: () => import('@/modules/UserEventLanding/components/event-landing/SectionAssociations.vue'),
      attrs: {
        id: 'associations',
      },
      listeners: {},
    },
    editor: {
      replacement: true,
      addition: false,
      deletable: false,
      activate: true,
    },
  }),
};

export const CARD_TYPES_DATA = Object.fromEntries(
  Object.values(CARD_TYPES).map((cardType) => [
    cardType,
    () => ({
      title: '',
      enabled: true,
      attrs: {
        class: 'redesignControlsBackground',
      },
      addons: {},
      component: {
        type: SECTION_TYPES.GENERIC,
        cardType,
        is: () => import('@/modules/UserEventLanding/components/event-landing/SectionCustom.vue'),
        attrs: {
          id: uuid(),
          cards: [],
          data: {
            cardType,
          },
        },
        listeners: {},
      },
      editor: {
        replacement: true,
        addition: true,
        deletable: true,
        activate: true,
      },
    }),
  ]),
);

export const CARD_TYPES_COMPONENTS = {
  [CARD_TYPES.LEFT_AVATAR]: {
    section: () => import('@/modules/UserEventLanding/components/event-landing/custom-sections/sections/SectionLeftAvatar.vue'),
    card: () => import('@/modules/UserEventLanding/components/event-landing/custom-sections/cards/CardLeftAvatar.vue'),
  },
  [CARD_TYPES.PROGRESS]: {
    section: () => import('@/modules/UserEventLanding/components/event-landing/custom-sections/sections/SectionProgress.vue'),
    card: () => import('@/modules/UserEventLanding/components/event-landing/custom-sections/cards/CardProgress.vue'),
  },
  [CARD_TYPES.QUESTION]: {
    section: () => import('@/modules/UserEventLanding/components/event-landing/custom-sections/sections/SectionQuestion.vue'),
    card: () => import('@/modules/UserEventLanding/components/event-landing/custom-sections/cards/CardQuestion.vue'),
  },
  [CARD_TYPES.THEME_LIST]: {
    section: () => import('@/modules/UserEventLanding/components/event-landing/custom-sections/sections/SectionThemeList.vue'),
    card: () => import('@/modules/UserEventLanding/components/event-landing/custom-sections/cards/CardThemeList.vue'),
  },
  [CARD_TYPES.TOP_AVATAR_SHADOW]: {
    section: () => import('@/modules/UserEventLanding/components/event-landing/custom-sections/sections/SectionTopAvatar.vue'),
    card: () => import('@/modules/UserEventLanding/components/event-landing/custom-sections/cards/CardTopAvatar.vue'),
  },
};
